import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { Layer } from '../model/layer.model';
import { LayerConfig } from '../../config/model/layer-config.model';
import { LayerCode } from '../enum/layer-code.enum';

@Injectable({
  providedIn: 'root',
})
export class LayerContainerService {
  private _layerList: Layer[] = [];

  constructor(private configService: ConfigService) {
    this.buildLayerList(this.configService.layerContainerConfig.layers);
  }

  public get layerList(): Layer[] {
    return this._layerList;
  }

  public fkLayerFromUrl(layerUrl: string): string {
    const layer = this.layerList.find(lyr => lyr.esriLayer['parsedUrl']?.path === layerUrl);
    if (!layer) return;
    return layer.fkLayer;
  }

  public getIdentifyLayerUrl(fkLayer: string): string {
    const identifyLyr = this.layerList.filter(f => f.fkLayer === fkLayer)[0];
    return identifyLyr.layerUrl;
  }

  public getActiveWorkspaceLyr(fkLayer: string): Layer[] {
    return this.layerList.filter(f => f.fkLayer === fkLayer);
  }

  public isIdentifyLayerVisible(fkLayer: LayerCode): boolean {
    const identifyLyr = this.layerList.filter(f => f.fkLayer === fkLayer)[0];
    const isGroupLyr = this.isGroupLayer(identifyLyr.esriLayer.parent as __esri.GroupLayer);
    if (isGroupLyr) {
      if (!(identifyLyr.esriLayer.parent as __esri.GroupLayer).visible) {
        return false;
      }
    }
    return identifyLyr.esriLayer.visible === true;
  }

  public getMapImageLayer(fkLayer: string): __esri.MapImageLayer {
    const lyr = this.layerList.filter(f => f.fkLayer === fkLayer)[0];
    return lyr.esriLayer as __esri.MapImageLayer;
  }

  private isGroupLayer(groupLyr: __esri.GroupLayer): boolean {
    return groupLyr.type === 'group';
  }

  private buildLayerList(configLyrs: Array<LayerConfig>) {
    const basePath = this.configService.baseUrl;

    if (configLyrs.length === 0) {
      return;
    }

    configLyrs.forEach(lyr => {
      // if layer published by G# then extend with the base path on service
      if (!lyr.externalService) {
        lyr.properties.url = basePath + lyr.properties.url;
      }
      const tocLyr = this.extendArbeitsbereichLyrProperties(lyr);
      this._layerList.push(new Layer(tocLyr));
    });
  }

  /**
   * @function extendArbeitsbereichLyrProperties
   * @param lyr
   * @description extend Arbeitsbereich layers with additional properties for further uses
   * @return lyr : with extended prperties
   */
  private extendArbeitsbereichLyrProperties(lyr: LayerConfig): LayerConfig {
    const arbeitsBereiche = this.configService.arbeitsbereichConfig.arbeitsbereiche;

    arbeitsBereiche.forEach(arBereich => {
      arBereich.layers.forEach(arbeitsbereichLyr => {
        if (!arbeitsbereichLyr.fkLayer) {
          return;
        }
        if (arbeitsbereichLyr.fkLayer === lyr.properties.id) {
          lyr.identify = arbeitsbereichLyr.identify;
          lyr.ignoreLayerIds = arbeitsbereichLyr.ignoreLayerIds;
          lyr.popUpInfo = arbeitsbereichLyr.popUpInfo;
        }
      });
    });
    return lyr;
  }
}
